export default __webpack_public_path__ + "static/media/influencers.d4648c78.svg";